// extracted by mini-css-extract-plugin
module.exports = {"root":"T_b4"};